module.exports = __webpack_public_path__ + "img/fb@1x.18c11ab4.webp";